import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { toDataSourceQuery } from '../common/grid-filter';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  ipAddress: string = '';

  constructor(private _http: HttpClient) { }

  getClientData() {
    return this._http.get<any>(`${environment.apiUrl}/Company/Get`);
  }

  getForAdmin() {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetForAdmin`);
  }
  getAllTransactions() {
    let token = localStorage['token'];
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token
    });
    return this._http.get<any>(`${environment.apiUrl}/Transactions/GetAllTransaction`, {
      headers: httpHeaders
    });
  }
  getAppointmentAndPatentCountByMonth(data: any) {
    return this._http.get<any>(`${environment.apiUrl}/Admin/GetAppointmentAndPatentCountByMonth?year=${data}`);
  }

  editClientData(data: any) {
    return this._http.post(`${environment.apiUrl}/Company/Update`, data);
  }
  updateForAdmin(data: any) {
    return this._http.post(`${environment.apiUrl}/Company/UpdateForAdmin`, data);
  }
  deleteClientData(data: any) {
    return this._http.delete(`${environment.apiUrl}/Company/Delete?id=${data}`,);
  }

  runMigrationData(data: any) {
    return this._http.post(`${environment.apiUrl}/Admin/AdminMigrationById?companyid=${data}`, data);
  }

  login(data: any) {
    return this._http.post(`${environment.apiUrl}/Admin/AdminLogin`, data);
  }
  changePass(data: any) {
    return this._http.post(`${environment.apiUrl}/Admin/Changepassword`, data);
  }
  updateProfile(data: any) {
    return this._http.post(`${environment.apiUrl}/Admin/UpdateAdminProfile`, data);
  }
  getAllUsers() {
    return this._http.get(`${environment.apiUrl}/Admin/getAllUsers`);
  }
  updateUserStatus(id: number, status: boolean) {
    return this._http.get(`${environment.apiUrl}/Admin/updateUserStatus?id=${id}&status=${status}`);
  }
  saveUser(data: any) {
    return this._http.post(`${environment.apiUrl}/Admin/saveUser`, data);
  }
  UpdatePassword(data: any) {
    return this._http.post(`${environment.apiUrl}/Admin/updatePassword`, data);
  }
  deleteUser(id: number) {
    return this._http.get(`${environment.apiUrl}/Admin/deleteUser?id=${id}`);
  }
  getActiveClient() {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetActiveAndNonActiveCount`);
  }

  addMigration() {
    return this._http.post(`${environment.apiUrl}/Admin/AdminMigration`, null);
  }

  AdminLoginData(data: any, domain: any) {
    if (domain != '') {
      localStorage.setItem('DomainUrl', domain);
    }
    else {
      localStorage.removeItem('DomainUrl');
    }
    return this._http.post(`${environment.apiUrl}/User/LoginForAdmin?Id=${data}`, data);
  }

  getDefaultLocation(userId: any) {
    var requestUrl = localStorage.getItem("DomainUrl");
    var token = localStorage['token'];
    let locationId = JSON.parse(localStorage['Location'] == undefined ? null : localStorage['Location']);
    let companyid = localStorage['companyId'];
    var ipAddress = localStorage.getItem('IA')
    //  let httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'X-Forwarded-For': `${ipAddress}`,
      'RequestUrl': requestUrl ? requestUrl : " "
    });
    let params = new HttpParams().set("companyId", companyid).set("locationId", (locationId || {}).id);

    return this._http.get(`${environment.apiUrl}/SelectedLocation/GetByUserId?userId=${userId}`,
      {
        headers: httpHeaders,
        params: params
      }
    );
  }
  getCompanyByIdpromise(Id: string) {
    var requestUrl = localStorage.getItem("DomainUrl");
    var token = localStorage['token'];
    let locationId = JSON.parse(localStorage['Location'] == undefined ? null : localStorage['Location']);
    let companyid = localStorage['companyId'];
    var ipAddress = localStorage.getItem('IA')
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'X-Forwarded-For': `${ipAddress}`,
      'RequestUrl': requestUrl ? requestUrl : " "
    });
    // let httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    let params = new HttpParams().set("companyId", companyid).set("locationId", (locationId || {}).id);

    return this._http.get(environment.apiUrl + '/Company/GetById?id=' + Id,
      {
        headers: httpHeaders,
        params: params
      }
    )
  }

  getAll(Id: string) {
    var requestUrl = localStorage.getItem("DomainUrl");
    var token = localStorage['token'];
    let locationId = JSON.parse(localStorage['Location'] == undefined ? null : localStorage['Location']);
    let companyid = localStorage['companyId'];
    var ipAddress = localStorage.getItem('IA')
    const httpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'X-Forwarded-For': `${ipAddress}`,
      'RequestUrl': requestUrl ? requestUrl : " "
    });
    // let httpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token, );
    let params = new HttpParams().set("companyId", companyid).set("locationId", (locationId || {}).id);

    return this._http.get(environment.apiUrl + '/GeneralSetting/GetAll?id=' + Id,
      {
        headers: httpHeaders,
        params: params
      }
    )
  }
  matchEmailName(Email: any) {
    let model = { Email: Email }
    return this._http.post(
      `${environment.apiUrl}/Company/CheckEmailExists`,
      model
    );
  }

  updateStatus(compnayId: any, StatusName: any) {
    return this._http.post(
      `${environment.apiUrl}/Company/UpdateStatus?compnayId=${compnayId}&StatusName=${StatusName}`, "");
  }
  getAllError(state: DataSourceRequestState, SearchText: any) {
    var queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/ELMAH_Error/GetAll?${queryStr}&SearchText=${SearchText}`);
  }

  getAllLoginLog(state: DataSourceRequestState, SearchText: any, StartDate: any, EndDate: any) {
    var queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/LoginLogs/GetLoginlog?${queryStr}&SearchText=${SearchText}&StartDate=${StartDate}&EndDate=${EndDate}`);
  }
  GetDeviceCount() {
    return this._http.get<any>(`${environment.apiUrl}/LoginLogs/GetDeviceCount`);
  }

  GetDeviceCountByMonth(year: number) {
    return this._http.get<any>(`${environment.apiUrl}/LoginLogs/GetDeviceCountByMonth`, {
      params: { year },
    });
  }

  GetDailyLoggedInUsers(startDate: string, endDate: string) {
    return this._http.get<any>(`${environment.apiUrl}/LoginLogs/GetDailyLoggedInUsers`, {
      params: { startDate, endDate },
    });
  }

  getIPAddress() {
    return this._http.get("https://api64.ipify.org?format=json");
  }

  getIPLocation() {
    return this._http.get("https://ipinfo.io/json");
  }
  // getAllError(state: DataSourceRequestState, errorFilterViewModel: any = {}) {
  //   return this._http.post(
  //     `${environment.endPoint}/GetAll?${toDataSourceRequestString(
  //       state
  //     )}`,
  //     errorFilterViewModel
  //   );
  // }
  getByIdError(id: any) {
    return this._http.get<any>(`${environment.apiUrl}/ELMAH_Error/GetById?id=${id}`);
  }
  sendAnnouncementEmailforAdmin(adminEmailDto: any) {
    return this._http.post(
      `${environment.apiUrl}/Company/SendAnnouncementEmailforAdmin`,
      adminEmailDto
    );
  }

  adminEmailTemplate(adminEmailTemplateDto: any) {
    return this._http.post(
      `${environment.apiUrl}/AdminEmailTemplate/Create`,
      adminEmailTemplateDto
    );
  }

  getTemplate() {
    return this._http.get<any>(`${environment.apiUrl}/AdminEmailTemplate/GetTemplate`);
  }

  getTemplateById(Id: any) {
    return this._http.get<any>(`${environment.apiUrl}/AdminEmailTemplate/Get?id=${Id}`);
  }

  DeleteTemplate(data: any) {
    return this._http.put(`${environment.apiUrl}/AdminEmailTemplate/Delete`, data);
  }
  getMaintenance() {
    return this._http.get<any>(`${environment.apiUrl}/UserMessage/Get`);
  }
  updateMaintenance(data: any) {
    return this._http.put(`${environment.apiUrl}/UserMessage/Update`, data);
  }
  addMaintenance(data: any) {
    return this._http.post(`${environment.apiUrl}/UserMessage/Create`, data);
  }
  getCountry() {
    return this._http.get<any>(
      `${environment.apiUrl}/Common/GetCountry`
    );
  }
  GetTransactionZeroAmount() {
    return this._http.get<any>(`${environment.apiUrl}/Transactions/GetTransactionZeroAmount`)
  }

  GetTransactionBigAmount(state: DataSourceRequestState, SearchText: any, Status: string = 'All') {
    SearchText = (!SearchText || SearchText.trim() === "") ? " " : SearchText;
    const queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/Transactions/GetTransactionBigAmount?${queryStr}&SearchText=${SearchText}&Status=${Status}`);
  }

  GetPlusPhysioDomain(state: DataSourceRequestState, SearchText: any, PlanFilter: string = 'All', AccountType: string = 'All', StatusFilter: string = 'All') {
    SearchText = (!SearchText || SearchText.trim() === "") ? " " : SearchText;
    const queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/Company/GetPlusPhysioDomain?${queryStr}&SearchText=${SearchText}&PlanFilter=${PlanFilter}&AccountType=${AccountType}&StatusFilter=${StatusFilter}`);
  }

  GetPlusDoctorDomain(state: DataSourceRequestState, SearchText: any, PlanFilter: string = 'All', AccountType: string = 'All', StatusFilter: string = 'All') {
    SearchText = (!SearchText || SearchText.trim() === "") ? " " : SearchText;
    const queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/Company/GetPlusDoctorDomain?${queryStr}&SearchText=${SearchText}&PlanFilter=${PlanFilter}&AccountType=${AccountType}&StatusFilter=${StatusFilter}`);
  }

  GetClientList(domain: string) {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetClientList?domain=${domain}`);
  }

  GetActiveAndNonActiveCountPhysio() {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetActiveAndNonActiveCountPhysio`);
  }
  GetActiveAndNonActiveCountPlusDoctor() {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetActiveAndNonActiveCountPlusDoctor`);
  }
  /** Plan payments due in the next `days` days and missed in the last `days` days - the dashboard's payment widgets. */
  getPaymentDashboard(days: number = 7) {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetPaymentDashboard`, { params: { days } });
  }
  /** Clients on a paid plan who have not logged in for more than `days` days, or never - the dashboard's inactive paid clients widget. */
  getInactivePaidClients(days: number = 7) {
    return this._http.get<any>(`${environment.apiUrl}/Company/GetInactivePaidClients`, { params: { days } });
  }
  AdminGridSettingAddData(data: any) {
    return this._http.post(
      `${environment.apiUrl}/AdminGridSetting/Create`,
      data
    );
  }
  GetDomainName(DomainName: any, TableName: any) {
    return this._http.get(
      `${environment.apiUrl}/AdminGridSetting/GetDomainName?DomainName=${DomainName}&TableName=${TableName}`
    );
  }

  createAddOnDetails(data: any[]) {
    return this._http.post(
      `${environment.apiUrl}/AddOnDetails/CreateAddOnDetails`,
      data
    );
  }

  getActiveAddOnDetails(companyId: number) {
    return this._http.get<any>(`${environment.apiUrl}/AddOnDetails/GetByCompanyId?companyId=${companyId}`);
  }

  getAddOnDetails(companyId: number) {
    return this._http.get<any>(`${environment.apiUrl}/AddOnDetails/GetAllByCompanyId?companyId=${companyId}`);
  }

  AddTransactionDetails(stripePaymentModel: any) {
    return this._http.post(`${environment.apiUrl}/Payment/AddTransactionDetails`, stripePaymentModel);
  }

  addMasterMigration() {
    return this._http.post(`${environment.apiUrl}/Admin/AdminMasterMigration`, null);
  }

  logoutAllUsers(companyId: number) {
    return this._http.post(`${environment.apiUrl}/Admin/ForceLogoutAllUsers?companyId=${companyId}`, {});
  }

  getLocations(companyId: number) {
    return this._http.get<any>(
      `${environment.apiUrl}/Company/GetCompanyLocations?companyId=${companyId}`
    );
  }

  enableWhatsappInstance(data: any) {
    return this._http.post(`${environment.apiUrl}/Company/EnableWhatsapp`, data);
  }

  resetPassword(data: any) {
    return this._http.post(`${environment.apiUrl}/Common/ResetPassword`, data);
  }

  updatePlanLimit(model: any) {
    return this._http.post(`${environment.apiUrl}/PlanLimit/UpdatePlanLimit`, model);
  }

  getPlanLimit(companyId: number) {
    return this._http.get<any>(`${environment.apiUrl}/PlanLimit/GetPlanLimits?companyId=${companyId}`);
  }

  updateCreditLimit(model: any) {
    return this._http.post(`${environment.apiUrl}/CreditLimit/AddCreditLimit`, model);
  }

  getCreditLimit(companyId: number) {
    return this._http.get<any>(`${environment.apiUrl}/CreditLimit/GetCreditLimits?companyId=${companyId}`);
  }

  cancelAutoRenew(subscriptionId: string) {
    return this._http.post(`${environment.apiUrl}/Payment/CancelSubscription?subscriptionId=${subscriptionId}`, {});
  }

  getSubscriptionDetails(companyId?: number) {
    return this._http.get<any>(`${environment.apiUrl}/Transactions/GetByTransactionAllCompanyId?companyId=${companyId}`);
  }

  getGeneralSetting(companyId: number, key: string) {
    return this._http.get(
      `${environment.apiUrl}/GeneralSetting/GetByDomain?companyId=${companyId}&key=${key}`
    );
  }

  updateGeneralSettingByDomain(companyId: number, data: any) {
    return this._http.post(
      `${environment.apiUrl}/GeneralSetting/UpdateByDomain?companyId=${companyId}`,
      data
    );
  }

  getUsageOverview(companyId: number) {
    return this._http.get<any>(`${environment.apiUrl}/AddOnDetails/GetUsageOverview?companyId=${companyId}`);
  }

  createDomain(companyId: number) {
    return this._http.post(`${environment.apiUrl}/Company/CreateDomain?companyId=${companyId}`, {});
  }

  checkWhatsAppConnection(instanceId: string) {
    return this._http.get(
      `https://whatsappphysioapi.ifourtechlab.com/api/whatsapp/check-connection/${instanceId}`
    );
  }

  generateWhatsAppQR(instanceId: string) {
    return this._http.get(
      `https://whatsappphysioapi.ifourtechlab.com/api/whatsapp/generate-qr/${instanceId}`
    );
  }

  logoutWhatsAppSession(instanceId: string) {
    return this._http.get(
      `https://whatsappphysioapi.ifourtechlab.com/api/whatsapp/logout-session/${instanceId}`
    );
  }

  importBulkMessage(file: File, campaignName: string, endDate: any, message: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('campaignName', campaignName || '');
    if (endDate) {
      formData.append('endDate', new Date(endDate).toISOString());
    }
    formData.append('message', message || '');

    return this._http.post(`${environment.apiUrl}/BulkMessage/Import`, formData);
  }

  importAndSaveBulkMessage(file: File, campaignName: string, endDate: any, message: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('campaignName', campaignName || '');
    if (endDate) {
      formData.append('endDate', new Date(endDate).toISOString());
    }
    formData.append('message', message || '');

    return this._http.post(`${environment.apiUrl}/BulkMessage/ImportAndSave`, formData);
  }

  getBulkMessages(state: DataSourceRequestState, searchText: string = '') {
    const queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/BulkMessage/Get?${queryStr}&SearchText=${searchText}`);
  }

  getCampaigns(state: DataSourceRequestState, searchText: string = '') {
    const queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/BulkMessage/GetCampaigns?${queryStr}&SearchText=${searchText}`);
  }

  getBulkMessagesByCampaign(campaignId: number, state: DataSourceRequestState) {
    const queryStr = `${toDataSourceQuery(state)}`;
    return this._http.get<any>(`${environment.apiUrl}/BulkMessage/GetByCampaign?campaignId=${campaignId}&${queryStr}`);
  }

  saveCampaignWithMessages(file: File, campaignData: any) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('campaignName', campaignData.CampaignName ?? '');
    if (campaignData.EndDate) {
      formData.append('endDate', new Date(campaignData.EndDate).toISOString());
    }
    if (campaignData.StartDate) {
      formData.append('startDate', new Date(campaignData.StartDate).toISOString());
    }
    formData.append('message', campaignData.Message ?? '');
    formData.append('dailyLimit', campaignData.DailyLimit?.toString() ?? '0');
    formData.append('minTimeGapMinutes', campaignData.MinTimeGapMinutes?.toString() ?? '0');
    formData.append('randomExtraMinutes', campaignData.RandomExtraMinutes?.toString() ?? '0');

    return this._http.post(`${environment.apiUrl}/BulkMessage/SaveCampaignWithMessages`, formData);
  }
  getCreditRule(companyId: number) {
    return this._http.get<any>(`${environment.apiUrl}/VisitPurpose/GetModality?companyId=${companyId}`);
  }
  updateCreditRules(data: any) {
    return this._http.post(`${environment.apiUrl}/VisitPurpose/UpdateModality?companyId=${data.CompanyId}`, data.modalityList);
  }

}
